import { useCallback } from 'react';

import { api } from '@shared/api';
import { UserStore } from '@shared/store';

import { useQuery } from '@tanstack/react-query';

import { useSwyftxMarginStore } from '../../state';

const useFetchMarginAccountDetails = () => {
  const { getUniqueIdentifier } = UserStore.useUserStore;
  const { traderAccountId } = useSwyftxMarginStore();

  const fetchAccountDetails = useCallback(async () => {
    if (!getUniqueIdentifier() || !traderAccountId) return;

    let response = await api.endpoints.getMarginAccountDetails({
      params: { swyftxUserId: getUniqueIdentifier(), traderAccountId },
    });

    return response.data;
  }, [traderAccountId, getUniqueIdentifier]);

  return useQuery({
    queryKey: ['margin-account-details', getUniqueIdentifier(), traderAccountId],
    queryFn: fetchAccountDetails,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    networkMode: 'always',
    retry: false,
  });
};

export { useFetchMarginAccountDetails };
